import { BaseEdge, getSmoothStepPath } from '@xyflow/react';

// Smoothstep edge with an infinite "flow" pulse traveling from the
// entry point toward the receiver (overlay path animated via CSS).
export default function SplitFlowEdge({
    id,
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
    style,
    data,
}) {
    const [edgePath] = getSmoothStepPath({
        sourceX,
        sourceY,
        targetX,
        targetY,
        sourcePosition,
        targetPosition,
        borderRadius: 24,
    });

    return (
        <>
            <BaseEdge id={id} path={edgePath} style={style} />
            {/* Live "flow" pulse only on active receivers — pending invitations
                are a not-yet-live arrangement and stay statically dashed. */}
            {data?.animated && (
                <path
                    d={edgePath}
                    className="split-edge-flow"
                    style={{ animationDelay: `${(data?.index ?? 0) * 220}ms` }}
                />
            )}
        </>
    );
}
